export const NOTIFICATION_TYPES = {
  PROMOTION_EXCHANGED: 'promotion.exchanged',
  REWARD_EXCHANGED: 'reward.exchanged',
  DEFAULT: 'notification',
  USER_ACTIVATED: 'user.activated'
};
